import React from 'react';
import { ChevronDown, LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import LanguageSelector from '../../../../components/LanguageSelector';

export default function Header({
    title,
    subtitle,
    children,
    showStandardSelector = false,
    showDivisionSelector = false,
    selectedStandard,
    selectedDivision,
    setSelectedStandard,
    setSelectedDivision
}) {
    const navigate = useNavigate();

    return (
        <header className="sticky top-0 z-30 bg-[#F8FAFC]/80 backdrop-blur-md px-8 py-6 -mx-8 mb-8">
            <div className="flex flex-col xl:flex-row xl:items-center justify-between gap-6 tracking-tight">
                <div>
                    <h1 className="text-[26px] font-black text-[#111827] mb-1">{title}</h1>
                    <p className="text-gray-400 font-medium text-[15px]">{subtitle}</p>
                </div>

                <div className="flex items-center gap-3">
                    {/* Optional Standard Selector */}
                    {showStandardSelector && (
                        <div className="flex items-center gap-4 px-4 py-2.5 bg-white border border-gray-100 rounded-xl text-[14px] font-bold text-gray-700 shadow-sm cursor-pointer hover:bg-gray-50 transition-all">
                            <span>{selectedStandard || 'Standard - 8'}</span>
                            <ChevronDown size={14} className="text-gray-400" />
                        </div>
                    )}

                    {/* Optional Division Selector */}
                    {showDivisionSelector && (
                        <div className="flex items-center gap-4 px-4 py-2.5 bg-white border border-gray-100 rounded-xl text-[14px] font-bold text-gray-700 shadow-sm cursor-pointer hover:bg-gray-50 transition-all">
                            <span>{selectedDivision || 'Division - C'}</span>
                            <ChevronDown size={14} className="text-gray-400" />
                        </div>
                    )}

                    {/* Additional children (Buttons, Search, etc.) */}
                    {children}

                    {/* Language Selector */}
                    <LanguageSelector variant="compact" />

                    {/* Unified Profile Avatar Section */}
                    <div className="ml-4 flex items-center gap-3 border-l border-gray-200 pl-6">
                        <button
                            onClick={() => navigate('/login')}
                            className="p-2.5 bg-white border border-gray-100 rounded-xl text-gray-400 hover:text-red-500 hover:bg-red-50 hover:border-red-100 transition-all shadow-sm group"
                            title="Sign Out"
                        >
                            <LogOut size={18} className="group-active:scale-95" />
                        </button>
                        <div className="w-11 h-11 rounded-full overflow-hidden border-2 border-white shadow-md hover:scale-105 transition-transform cursor-pointer">
                            <img
                                src="https://api.dicebear.com/7.x/avataaars/svg?seed=Sarah"
                                alt="Profile"
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
}
